<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      class="item"
      effect="dark"
      content="Átvétel"
      placement="top"
      v-can="'representativedrop.update'"
      v-if="representativeDrop.status === 'dropped'"
    >
      <el-button
        type="success"
        size="mini"
        :loading="receiveButtonLoader"
        icon="el-icon-check"
        @click="receiveRepresentativeDrop"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      content="Export"
      placement="top"
    >
      <el-button
        size="mini"
        :loading="exportButtonLoader"
        icon="el-icon-download"
        @click="exportRepresentativeDrop"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      v-can="'representativeorder.update'"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click="updateRepresentativeOrder"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      content="Bizonylat nyomtatása"
      placement="top"
      v-can="'representativedrop.view'"
      v-if="representativeDrop.status !== 'recorded' && representativeDrop.status !== 'cancelled' && representativeDrop.receipt_file"
    >
      <el-button
        size="mini"
        icon="el-icon-printer"
        style="margin-left: 5px;"
        @click="openReceipt"
      />
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['representativeDrop'],
    data() {
      return {
        receiveButtonLoader: false,
        sendButtonLoader: false,
        deleteConfirmVisible: false,
        cancelButtonLoader: false,
        undoCancelButtonLoader: false,
        exportButtonLoader: false,
      };
    },

    methods: {

      async receiveRepresentativeDrop() {
        this.receiveButtonLoader = true;
        try {
          await this.$store.dispatch('representativeDrop/receive', this.representativeDrop.id);
        } catch (e) {
        }
        this.receiveButtonLoader = false;
        this.$store.dispatch('representativeDrop/fetchAll');
      },

      async updateRepresentativeOrder() {
        this.$router.push('/representative-processes/representative-drops/update/' + this.representativeDrop.id);
      },

      openReceipt() {
        if (this.representativeDrop.receipt_file) {
          window.open(this.representativeDrop.receipt_file);
        }
      },
       async exportRepresentativeDrop() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/representative-drops/' + this.representativeDrop.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'representative_drop_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },
    }
  };
</script>
